/* eslint-disable no-unused-vars */
/**
 * tables: tb_profiles & tb_type_users
 * profiles: 1 = admin, 2 = usuario, 3 = vendedor
 * typeusers: 1 = operadora 2 = corretora  3 = cliente
 */
import React, { useEffect, useState } from 'react';
import { Grid, Container, Typography, Alert, Fade } from '@mui/material';
import {
  AppGraphs,
  AppWidgetSummary,
  AppGraphsDonuts,
  AppGraphsBar
} from '../../../sections/dashboard/dash';
import { selectLogin } from '../../../../store/login/loginSlice';
import { useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';

const DashboardApp = () => {
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const [infosSummaryClients, setInfosSummaryClients] = useState(0);
  const [infosSummarySimulations, setInfosSummarySimulations] = useState(0);
  const [infosSummaryClientsApproved, setInfosSummaryClientsApproved] = useState(0);
  const [infosSummarySimulationsFinished, setInfosSummarySimulationsFinished] = useState(0);
  const [infosLabelsGraphsClients, setInfosLabelsGraphsClients] = useState([]);
  const [infosDataGraphsClients, setInfosDataGraphsClients] = useState([]);
  const [infosLabelsGraphsSimulations, setInfosLabelGraphsSimulations] = useState([]);
  const [infosDataGraphsSimulations, setInfosDataGraphsSimulations] = useState([]);
  const [infosLabelsGraphsStatus, setInfosLabelGraphsStatus] = useState([]);
  const [infosDataGraphsStatus, setInfosDataGraphsStatus] = useState([]);
  const [infosLabelGraphsPlans, setInfosLabelGraphsPlans] = useState([]);
  const [infosDataGraphsPlans, setInfosDataGraphsPlans] = useState([]);
  const [infosLabelGraphsBrokers, setInfosLabelGraphsBrokers] = useState([]);
  const [infosDataGraphsBrokers, setInfosDataGraphsBrokers] = useState([]);
  const [infosLabelGraphsVend, setInfosLabelGraphsVend] = useState([]);
  const [infosDataGraphsVend, setInfosDataGraphsVend] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [warning, setWarning] = useState({});

  useEffect(() => {
    Promise.all([
      getInfosSummaryClients(),
      getInfosSummarySimulations(),
      getInfosGraphsClients(),
      getInfosGraphsSimulations(),
      getInfosGraphsStatus(),
      getInfosGraphsPlans(),
      getWarningDisplay()
    ]);

    if (infoState.id_type_user === 1 || infoState.id_profile === 2 || infoState.id_profile === 1) {
      getInfosGraphsVend();
    }

    if (infoState.id_type_user === 1) {
      getInfosGraphsBrokers();
    }
  }, []);

  async function getInfosSummaryClients() {
    let router;

    if (infoState.id_type_user === 1) {
      router = `/dashboard/summaryClients/?id_type_user=${infoState.id_type_user}`;
    } else if (
      (infoState.id_type_user === 2 && infoState.id_profile === 1) ||
      infoState.id_profile === 2
    ) {
      router = `/dashboard/summaryClients/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}`;
    } else {
      router = `/dashboard/summaryClients/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}&id_user=${infoState.id}`;
    }

    await configAxios
      .get(router)
      .then((response) => {
        let infosSummaryClientsCount = 0;
        let infosSummaryClientsApprovedCount = 0;

        response.data.map((element) => {
          if (element.statusvenda === 'Aprovada') {
            infosSummaryClientsApprovedCount++;
          } else {
            infosSummaryClientsCount++;
          }
        });
        setInfosSummaryClients(infosSummaryClientsCount);
        setInfosSummaryClientsApproved(infosSummaryClientsApprovedCount);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os clientes! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosSummarySimulations() {
    let router;

    if (infoState.id_type_user === 1) {
      router = `/dashboard/summarySimulations/?id_type_user=${infoState.id_type_user}`;
    } else if (
      infoState.id_type_user === 2 &&
      (infoState.id_profile === 1 || infoState.id_profile === 2)
    ) {
      router = `/dashboard/summarySimulations/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}`;
    } else {
      router = `/dashboard/summarySimulations/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}&id_user=${infoState.id}`;
    }

    await configAxios
      .get(router)
      .then((response) => {
        let infosSummarySimulationsCount = 0;
        let infosSummarySimulationsFinishedCount = 0;
        response.data.map((element) => {
          if (element.status === 'Fechada') {
            infosSummarySimulationsFinishedCount++;
          } else {
            infosSummarySimulationsCount++;
          }
        });
        setInfosSummarySimulations(infosSummarySimulationsCount);
        setInfosSummarySimulationsFinished(infosSummarySimulationsFinishedCount);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre as simulações! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosGraphsClients() {
    let router;

    if (infoState.id_type_user === 1) {
      router = '/dashboard/graphsClients';
    } else if (
      infoState.id_type_user === 2 &&
      (infoState.id_profile === 1 || infoState.id_profile === 2)
    ) {
      router = `/dashboard/graphsClients/?id_broker=${infoState.id_broker}`;
    } else {
      router = `/dashboard/graphsClients/?id_broker=${infoState.id_broker}&id_user=${infoState.id}`;
    }

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.day);
        });

        response.data.map((element) => {
          data.push(element.dia);
        });

        setInfosLabelsGraphsClients(labels);
        setInfosDataGraphsClients(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os gráficos das vendas! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getWarningDisplay() {
    const direcao = infoState.id_type_user === 1 ? 'Operadora' : 'Corretora';
    configAxios
      .get(`warnings/getWarning/${direcao}`)
      .then((response) => {
        if (Object.keys(response.data).length > 0) {
          setWarning(response.data);
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 10000);
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os avisos, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosGraphsSimulations() {
    let router;

    if (infoState.id_type_user === 1) {
      router = `/dashboard/graphsSimulations/?id_type_user=${infoState.id_type_user}`;
    } else if (
      infoState.id_type_user === 2 &&
      (infoState.id_profile === 1 || infoState.id_profile === 2)
    ) {
      router = `/dashboard/graphsSimulations/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}`;
    } else {
      router = `/dashboard/graphsSimulations/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}&id_user=${infoState.id}`;
    }

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.day);
        });

        response.data.map((element) => {
          data.push(element.dia);
        });

        setInfosLabelGraphsSimulations(labels);
        setInfosDataGraphsSimulations(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os gráficos das simulações! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosGraphsStatus() {
    let router;

    if (infoState.id_type_user === 1) {
      router = `/dashboard/getInfosGraphsSalesStatus/?id_type_user=${infoState.id_type_user}`;
    } else if (
      infoState.id_type_user === 2 &&
      (infoState.id_profile === 1 || infoState.id_profile === 2)
    ) {
      router = `/dashboard/getInfosGraphsSalesStatus/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}`;
    } else {
      router = `/dashboard/getInfosGraphsSalesStatus/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}&id_user=${infoState.id}`;
    }

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.statusvenda);
        });

        response.data.map((element) => {
          data.push(element.total);
        });
        setInfosLabelGraphsStatus(labels);
        setInfosDataGraphsStatus(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os gráficos dos status! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosGraphsPlans() {
    let router;

    if (infoState.id_type_user === 1) {
      router = `/dashboard/getInfosGraphsPlans/?id_type_user=${infoState.id_type_user}`;
    } else if (
      infoState.id_type_user === 2 &&
      (infoState.id_profile === 1 || infoState.id_profile === 2)
    ) {
      router = `/dashboard/getInfosGraphsPlans/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}`;
    } else {
      router = `/dashboard/getInfosGraphsPlans/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}&id_user=${infoState.id}`;
    }

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.descplano);
        });

        response.data.map((element) => {
          data.push(element.total);
        });
        setInfosLabelGraphsPlans(labels);
        setInfosDataGraphsPlans(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os gráficos dos planos! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosGraphsBrokers() {
    let router = `/dashboard/getInfosGraphsBrokers`;

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.nomefantasia);
        });

        response.data.map((element) => {
          data.push(element.total);
        });
        setInfosLabelGraphsBrokers(labels);
        setInfosDataGraphsBrokers(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os gráficos dos planos! Tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosGraphsVend() {
    let router;

    if (infoState.id_type_user === 1) {
      router = `/dashboard/getInfosGraphsVend/?id_type_user=${infoState.id_type_user}`;
    } else if (
      infoState.id_type_user === 2 &&
      (infoState.id_profile === 1 || infoState.id_profile === 2)
    ) {
      router = `/dashboard/getInfosGraphsVend/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}`;
    } else {
      router = `/dashboard/getInfosGraphsVend/?id_type_user=${infoState.id_type_user}&id_broker=${infoState.id_broker}&id_user=${infoState.id}`;
    }

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.nome);
        });

        response.data.map((element) => {
          data.push(element.total);
        });
        setInfosLabelGraphsVend(labels);
        setInfosDataGraphsVend(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os gráficos dos vendedores! Tente novamente!',
          'Atenção'
        );
      });
  }

  return (
    <RenderPage title="Dashboard">
      <Container maxWidth="xl">
        {showAlert && (
          <Grid container spacing={3} sx={{ mb: 2 }}>
            <Grid item xs={12} md={12}>
              <Fade in={showAlert} style={{ transformOrigin: '0 0 0' }}>
                <Alert severity={warning.severity}>
                  <Typography variant="subtitle2">Aviso: {warning.warning}</Typography>
                </Alert>
              </Fade>
            </Grid>
          </Grid>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Propostas cadastradas"
              total={infosSummaryClients}
              icon={'eva:person-add-outline'}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Simulações cadastradas"
              total={infosSummarySimulations}
              icon={'ant-design:exception-outlined'}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Vendas finalizadas"
              total={infosSummaryClientsApproved}
              icon={'eva:person-done-outline'}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Simulações finalizadas"
              total={infosSummarySimulationsFinished}
              icon={'ant-design:file-done-outlined'}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={3}>
            <AppGraphsDonuts
              title="120"
              subheader="Vendas cadastradas"
              name="Vendas"
              chartLabels={infosLabelClients}
              chartData={[{ data: infosSummaryClients, colors: '#64FFC6' }]}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppGraphsDonuts
              title="250"
              subheader="Simulações cadastradas"
              name="Simulações"
              chartLabels={'Cadastradas'}
              chartData={[{ data: infosSummarySimulations, colors: '#FF7E90' }]}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppGraphsDonuts
              title="440"
              subheader="Vendas finalizadas"
              name="Vendas"
              chartLabels={infosLabelClientsApproved}
              chartData={[{ data: infosSummaryClientsApproved, colors: '#64FFC6' }]}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppGraphsDonuts
              title="120"
              subheader="Simulações finalizadas"
              name="Simualações"
              chartLabels={infosLabelSimulationsFinished}
              chartData={[{ data: infosSummarySimulationsFinished, colors: '#FF7E90' }]}
            />
          </Grid> */}
          <Grid item xs={12} md={6} lg={6}>
            <AppGraphs
              title="Propostas realizadas por período"
              subheader="Acompanhe o desempenho de vendas do último ano separadas por mês"
              chartLabels={infosLabelsGraphsClients}
              name="Vendas"
              chartData={[
                {
                  name: 'Vendas',
                  type: 'line',
                  fill: 'solid',
                  color: '#64FFC6',
                  data: infosDataGraphsClients
                }
              ]}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <AppGraphs
              title="Simulações realizadas por período"
              subheader="Acompanhe as simulações do último ano separadas por mês"
              chartLabels={infosLabelsGraphsSimulations}
              name="Simulações"
              chartData={[
                {
                  name: 'Simulações',
                  type: 'line',
                  fill: 'solid',
                  color: '#FF7E90',
                  data: infosDataGraphsSimulations
                }
              ]}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <AppGraphsDonuts
              title="Propostas por status"
              subheader="Distribuição das vendas por status atual"
              name="Vendas"
              chartLabels={infosLabelsGraphsStatus}
              chartData={infosDataGraphsStatus}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <AppGraphsBar
              title="Propostas por plano"
              subheader="Número de vendas por cada tipo de plano"
              name="Vendas"
              chartLabels={infosLabelGraphsPlans}
              chartData={infosDataGraphsPlans}
            />
          </Grid>
          {infoState.id_type_user === 1 && (
            <Grid item xs={12} md={6} lg={6}>
              <AppGraphsBar
                title="Propostas por corretora"
                subheader="Perfomance por agência corretora"
                name="Vendas"
                chartLabels={infosLabelGraphsBrokers}
                chartData={infosDataGraphsBrokers}
              />
            </Grid>
          )}
          {(infoState.id_type_user === 1 ||
            infoState.id_profile === 2 ||
            infoState.id_profile === 1) && (
            <Grid item xs={12} md={6} lg={6}>
              <AppGraphsBar
                title="Propostas por vendedor"
                subheader="Vendas separadas por vendedor"
                name="Vendas"
                chartLabels={infosLabelGraphsVend}
                chartData={infosDataGraphsVend}
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </RenderPage>
  );
};

export default DashboardApp;
